import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';
import { AxiosError } from 'axios';
import { klwAxios } from 'helpers/api';

export const useAccorderen = (): UseMutationResult<void, unknown, void, unknown> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => klwAxios.post('/Menu/Accorderen', { params: { kringloopwijzerId: Number(localStorage.getItem('KringloopwijzerId')) } }).then(r => r.data),
    onSuccess: () => {
      notification.success({ message: 'Kringloopwijzer is ingediend' });
      queryClient.invalidateQueries({ queryKey: ['Menu'] });
      queryClient.invalidateQueries({ queryKey: ['Home'] });
    },
    onError: (err: AxiosError<{ message: string }>) => {
      notification.error({ message: err.response.data.message });
    },
  });
};

export const useAccorderenTerugdraaien = (): UseMutationResult<void, unknown, void, unknown> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () =>
      klwAxios.post('/Menu/AccorderenTerugdraaien', { params: { kringloopwijzerId: Number(localStorage.getItem('KringloopwijzerId')) } }).then(r => r.data),
    onSuccess: () => {
      notification.success({ message: 'Kringloopwijzer is niet langer ingediend' });
      queryClient.invalidateQueries({ queryKey: ['Menu'] });
      queryClient.invalidateQueries({ queryKey: ['Home'] });
    },
    onError: (err: AxiosError<{ message: string }>) => {
      notification.error({ message: err.response.data.message });
    },
  });
};
